<script>
  import { format } from 'svelte-i18n';

  import { Chart } from '@client/components/charts';

  import { CHART_TYPES } from '@client/enums';

  export let data = {};
  export let label = null;
  export let title = null;
  export let subtitle = null;
  export let height = 'auto';
  export let width = 'auto';

  let tooltip =
    'This chart aggregates all email views for the current time period, and displays them by day of week and time of day. This tells you when people are most likely to engage with your emails.';

  let options = {
    responsive: true,
    animation: false,
    plugins: {
      legend: false
    },
    helpers: {
      tooltipValueFormatter(value) {
        const [time, , total] = value.replace(/[()]/g, '').split(', ');
        return `${time} - ${Math.ceil(total / 2)} views`;
      }
    },
    scales: {
      y: {
        type: 'category',
        position: 'left',
        labels: [
          $format('label.DAYS_SHORTENED.SUN'),
          $format('label.DAYS_SHORTENED.MON'),
          $format('label.DAYS_SHORTENED.TUE'),
          $format('label.DAYS_SHORTENED.WED'),
          $format('label.DAYS_SHORTENED.THU'),
          $format('label.DAYS_SHORTENED.FRI'),
          $format('label.DAYS_SHORTENED.SAT')
        ]
      },
      x: {
        type: 'category',
        position: 'bottom',
        min: '12AM',
        max: '11PM',
        ticks: {
          maxRotation: 0,
          callback(value, index) {
            return index % 2 === 0 ? this.getLabelForValue(value) : '';
          }
        },
        labels: [
          '12AM',
          '12:30AM',
          '1AM',
          '1:30AM',
          '2AM',
          '2:30AM',
          '3AM',
          '3:30AM',
          '4AM',
          '4:30AM',
          '5AM',
          '5:30AM',
          '6AM',
          '6:30AM',
          '7AM',
          '7:30AM',
          '8AM',
          '8:30AM',
          '9AM',
          '9:30AM',
          '10AM',
          '10:30AM',
          '11AM',
          '11:30AM',
          '12PM',
          '12:30PM',
          '1PM',
          '1:30PM',
          '2PM',
          '2:30PM',
          '3PM',
          '3:30PM',
          '4PM',
          '4:30PM',
          '5PM',
          '5:30PM',
          '6PM',
          '6:30PM',
          '7PM',
          '7:30PM',
          '8PM',
          '8:30PM',
          '9PM',
          '9:30PM',
          '10PM',
          '10:30PM',
          '11PM',
          '11:30PM'
        ]
      }
    }
  };
</script>

<Chart
  type={CHART_TYPES.bubble.id}
  bind:tooltip
  bind:data
  bind:options
  bind:label
  bind:title
  bind:subtitle
  bind:height
  bind:width
/>
